import { render, staticRenderFns } from "./CorrectDialog.vue?vue&type=template&id=474070dc&scoped=true&"
import script from "./CorrectDialog.vue?vue&type=script&lang=js&"
export * from "./CorrectDialog.vue?vue&type=script&lang=js&"
import style0 from "./CorrectDialog.vue?vue&type=style&index=0&id=474070dc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "474070dc",
  null
  
)

export default component.exports